module.exports = __webpack_public_path__ + "assets/webgl/Assets_3_base_color_L0.jpg.2e5ccf87.webp";